import { Button } from '@/components/ui';
import { videoErrorText } from '@/features/video-consults/format';
import styles from './video.module.css';

/** An API or SDK failure: what happened, what to do, the requestId to quote. */
export function VideoError({
  error,
  title,
  onRetry,
  retryLabel = 'Try again',
}: {
  error: unknown;
  title?: string;
  onRetry?: () => void;
  retryLabel?: string;
}) {
  const text = videoErrorText(error);
  return (
    <div className={styles.alert} role="alert">
      <strong>{title ?? text.title}</strong>
      {title && text.title !== title && <> · {text.title}</>}
      {text.body && <> {text.body}</>}
      {text.requestId && (
        <span className={styles.requestId}>Request {text.requestId}</span>
      )}
      {onRetry && (
        <div className={styles.alertAction}>
          <Button size="sm" onClick={onRetry}>
            {retryLabel}
          </Button>
        </div>
      )}
    </div>
  );
}
